import { useState } from 'react';
import { iaApi } from '../../api/resources';
import { Bar } from '../../components/ui/Bar.jsx';
import { Btn } from '../../components/ui/Btn.jsx';
import { Card } from '../../components/ui/Card.jsx';
import { Inp } from '../../components/ui/Inputs.jsx';
import { messageIa } from '../../lib/ia';
import { C } from '../../theme/palette';

/**
 * Les trois textes que l'on demande le plus, et ce qu'ils deviennent pour le
 * serveur : une description de ligne, ou un paragraphe de courrier dont le
 * titre dit l'intention.
 */
const GENRES = {
  devis: { libelle: 'Descriptif devis', genre: 'devis', titre: (s) => s },
  relance: {
    libelle: 'Relance impayé',
    genre: 'courrier',
    titre: (s) => 'Rappel de paiement — ' + s,
  },
  mail: { libelle: 'E-mail client', genre: 'courrier', titre: (s) => s },
};

/**
 * Rédaction libre : un sujet, un texte prêt à coller.
 *
 * Le texte était composé à partir de phrases toutes faites : la même
 * description quel que soit le chantier. Il vient désormais du Pack IA, avec le
 * métier de la société ; l'utilisateur le copie où il veut, et le corrige.
 *
 * @returns {import('react').ReactElement} la carte de rédaction
 */
export function RedactionIa() {
  const [kind, setKind] = useState('devis');
  const [sujet, setSujet] = useState('');
  const [sortie, setSortie] = useState('');
  const [enCours, setEnCours] = useState(false);
  const [erreur, setErreur] = useState('');
  const [copie, setCopie] = useState(false);

  const genere = async () => {
    const s = sujet.trim();
    if (!s || enCours) return;
    setEnCours(true);
    setErreur('');
    setSortie('');
    try {
      const g = GENRES[kind];
      const { texte } = await iaApi.redaction({ genre: g.genre, titre: g.titre(s), mots: '' });
      setSortie(texte);
    } catch (e) {
      setErreur(messageIa(e));
    } finally {
      setEnCours(false);
    }
  };

  return (
    <Card>
      <Bar
        icon="✨"
        title="Assistant rédaction"
        color={C.purple}
        sub="Génère un texte prêt à coller"
      />
      <div style={{ padding: 13 }}>
        <div style={{ display: 'flex', gap: 6, marginBottom: 10 }}>
          {Object.entries(GENRES).map(([k, g]) => (
            <div
              key={k}
              onClick={() => {
                setKind(k);
                setSortie('');
              }}
              style={{
                flex: 1,
                textAlign: 'center',
                padding: '8px 4px',
                borderRadius: 8,
                fontSize: 9,
                fontWeight: 700,
                cursor: 'pointer',
                background: kind === k ? C.purple : C.white,
                color: kind === k ? '#fff' : C.grey,
                border: '1px solid ' + C.border,
              }}
            >
              {g.libelle}
            </div>
          ))}
        </div>
        <Inp
          label="Sujet / mots-clés"
          value={sujet}
          onChange={(e) => setSujet(e.target.value)}
          placeholder={
            kind === 'devis' ? 'ex : pose carrelage salle de bain' : 'ex : facture F-2025-001'
          }
        />
        <Btn
          label={enCours ? '✨ Génération en cours…' : '✨ Générer le texte'}
          color={C.purple}
          full
          disabled={enCours || !sujet.trim()}
          onClick={genere}
        />
        {erreur && (
          <div role="alert" style={{ fontSize: 9.5, color: C.red, marginTop: 8, lineHeight: 1.5 }}>
            {erreur}
          </div>
        )}
        {sortie && (
          <div style={{ marginTop: 11 }}>
            <div
              style={{
                background: C.purpleL,
                border: '1px solid ' + C.purple + '28',
                borderRadius: 9,
                padding: '11px 12px',
                fontSize: 9.5,
                color: C.ink,
                whiteSpace: 'pre-wrap',
                lineHeight: 1.6,
              }}
            >
              {sortie}
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 6 }}>
              <button
                type="button"
                onClick={() => {
                  try {
                    navigator.clipboard && navigator.clipboard.writeText(sortie);
                    setCopie(true);
                  } catch (e) {
                    setCopie(false);
                  }
                }}
                style={{
                  background: 'none',
                  border: 'none',
                  color: C.purple,
                  fontSize: 9,
                  fontWeight: 700,
                  cursor: 'pointer',
                }}
              >
                {copie ? '✓ Copié' : '📋 Copier'}
              </button>
            </div>
          </div>
        )}
      </div>
    </Card>
  );
}
